module.exports = __webpack_public_path__ + "assets/images/boundaries/details/5-members.svg?v=2e082850";